/**
 * Status enums as constant arrays for runtime validation
 */

import type { LeadStatus, LeadSource } from '../types/lead'
import type { CampaignStatus } from '../types/campaign'
import type { PostStatus, ContentType } from '../types/post'
import type { MessageDirection, MessageType, Sentiment, ReplyClassification } from '../types/message'
import type { EngagementType, IntentClassification } from '../types/engagement'
import type { SignalType, SignalSource, SignalStrength } from '../types/signal'
import type { ConversationStatus } from '../types/conversation'
import type { KbDocStatus, KbDocType } from '../types/knowledge-base'

export const LEAD_STATUSES: readonly LeadStatus[] = [
  'discovered',
  'warmup',
  'contacted',
  'connection_sent',
  'connected',
  'replied',
  'qualified',
  'meeting_booked',
  'won',
  'lost',
] as const

export const LEAD_SOURCES: readonly LeadSource[] = [
  'search',
  'import',
  'engagement',
  'manual',
  'auto_discover',
] as const

export const CAMPAIGN_STATUSES: readonly CampaignStatus[] = [
  'draft',
  'active',
  'paused',
  'completed',
  'deleted',
] as const

export const POST_STATUSES: readonly PostStatus[] = [
  'draft',
  'approved',
  'scheduled',
  'published',
] as const

export const CONTENT_TYPES: readonly ContentType[] = [
  'thought_leadership',
  'pain_point',
  'social_proof',
  'cta',
  'industry_insight',
] as const

export const MESSAGE_DIRECTIONS: readonly MessageDirection[] = [
  'outbound',
  'inbound',
] as const

export const MESSAGE_TYPES: readonly MessageType[] = [
  'connection_request',
  'dm',
  'follow_up_1',
  'follow_up_2',
  'follow_up_3',
  'follow_up_4',
  'follow_up_5',
  'follow_up_6',
  'follow_up_7',
  'reply',
  'inmail',
] as const

export const SENTIMENTS: readonly Sentiment[] = [
  'positive',
  'negative',
  'neutral',
  'ooo',
] as const

export const REPLY_CLASSIFICATIONS: readonly ReplyClassification[] = [
  'interested',
  'not_interested',
  'question',
  'objection',
  'meeting_request',
  'ooo',
  'referral',
] as const

export const ENGAGEMENT_TYPES: readonly EngagementType[] = [
  'like',
  'comment',
  'share',
  'profile_view',
  'post_view',
] as const

export const INTENT_CLASSIFICATIONS: readonly IntentClassification[] = [
  'interested',
  'curious',
  'agreement',
  'generic',
  'promotional',
  'negative',
] as const

export const SIGNAL_TYPES: readonly SignalType[] = [
  'post_engagement',
  'profile_view',
  'job_change',
  'funding',
  'competitor_engagement',
  'content_download',
  'website_visit',
] as const

export const SIGNAL_SOURCES: readonly SignalSource[] = [
  'unipile',
  'perplexity',
  'manual',
] as const

export const SIGNAL_STRENGTHS: readonly SignalStrength[] = [
  'weak',
  'moderate',
  'strong',
] as const

export const CONVERSATION_STATUSES: readonly ConversationStatus[] = [
  'active',
  'paused',
  'escalated',
  'closed',
] as const

export const KB_DOC_STATUSES: readonly KbDocStatus[] = [
  'processing',
  'ready',
  'error',
] as const

export const KB_DOC_TYPES: readonly KbDocType[] = [
  'pdf',
  'docx',
  'txt',
  'url',
] as const
